import { api } from "@/lib/api-client"

// Egress proxy diagnostics (#2645, companion to #2637)

export type EgressCheckStatus = "pass" | "fail" | "skipped"

export type EgressCheck = {
  status: EgressCheckStatus
  latency_ms?: number
  detail?: string
}

export type EgressDiagnosticsResponse = {
  egress: {
    mode: "proxy" | "direct"
    proxy: string | null
    source: string
    proxied_integrations: string[]
    legacy_ambient_proxy_vars: Record<string, boolean>
    ambient_vars_present: boolean
  }
  target: string
  checks: {
    tcp_reach: EgressCheck
    proxied_probe: EgressCheck
    direct_probe: EgressCheck
  }
}

export async function getEgressDiagnostics(): Promise<EgressDiagnosticsResponse> {
  const response = await api.get("/admin/egress/diagnose")
  return response.data || response
}
